// Common constants used across calculators
export const ROUNDING_VALUES = {
  STRESS_KPSI: 0,
  STRESS_GPA: 3,
  TENSION: 0,
  BENDING_RADIUS: 2,
  STRAIN_PERCENT: 2,
} as const;

export const CONVERSION_FACTORS = {
  KSI_TO_GPA: 0.00689476,        // 1 kpsi = ~0.00689476 GPa
  MPA_TO_KSI: 0.145037776,          // 1 MPa = ~0.145038 kpsi
  KSI_TO_MPA: 6.89476,          // 1 kpsi = ~6.89476 MPa
  GPA_TO_MPA: 1000,              // 1 GPa = 1000 MPa
  GRAVITY: 9.807,                // m/s² (standard gravity)
} as const;

export const MATERIAL_CONSTANTS = {
  YOUNGS_MODULUS_GPA: 75,        // Glass fiber Young's modulus in GPa
  E0_MPA: 70326,                 // Modulus of elasticity in MPa
} as const;

export const DEFAULT_VALUES = {
  CLADDING_DIAMETER_MICRONS: 125, // μm
  BEND_RADIUS_MM: 25.7,          // mm
} as const;

export default {
  ROUNDING_VALUES,
  CONVERSION_FACTORS,
  MATERIAL_CONSTANTS,
  DEFAULT_VALUES,
};